document.addEventListener('DOMContentLoaded', function() {
  // 1. Ленивая загрузка изображений
  const images = document.querySelectorAll('img:not([loading="lazy"])');
  images.forEach(img => {
    img.setAttribute('loading', 'lazy');
    // Задаём размеры, чтобы избежать сдвигов контента (CLS)
    if (!img.hasAttribute('width') || !img.hasAttribute('height')) {
      img.setAttribute('width', img.naturalWidth || 300);
      img.setAttribute('height', img.naturalHeight || 300);
    }
  });

  // 2. Минимальная высота для блока отзывов (уменьшает CLS)
  const reviewsContainer = document.querySelector('.jdgm-rev-widg');
  if (reviewsContainer) {
    reviewsContainer.style.minHeight = '200px';
  }

  // 3. Дополнительная проверка для блока You May Also Like
  const relatedProducts = document.querySelector('.product-list');
  if (relatedProducts) {
    relatedProducts.style.width = '100%';
    relatedProducts.style.maxWidth = '100%';
    relatedProducts.style.boxSizing = 'border-box';
    relatedProducts.style.display = 'grid';
    relatedProducts.style.gridTemplateColumns = 'repeat(auto-fit, minmax(150px, 1fr))';
    relatedProducts.style.gap = 'var(--spacing-4)';
  }
});